import { FormActions } from './Actions';
import { AvatarInput } from './AvatarInput';
import { Checkbox } from './Checkbox';
import { FormDateTime } from './DateTime/FormDateTime';
import { Form as FormComponent } from './Form';
import { FormColorPicker } from './FormColorPicker';
import { FormFile } from './FormFile';
import { FormImage } from './FormImage';
import { FormLabelPicker } from './FormLabelPicker';
import { FormMemberPicker } from './FormMemberPicker';
import { FormPostPicker } from './FormPostPicker';
import { FormSpacePicker } from './FormSpacePicker';
import { FormTagPicker } from './FormTagPicker';
import { Input } from './Input';
import { InputCopy } from './InputCopy';
import { FormLayout } from './Layout';
import { Multiselect } from './Multiselect';
import { RadioGroup } from './Radio';
import { SearchableSelect } from './SearchableSelect';
import { Select } from './Select';
import { FormSlider } from './Slider';
import { Textarea } from './Textarea';
import { Toggle } from './Toggle';
export * from './typings';
export const Form = FormComponent;
/**
 * @deprecated use Form.Image variant="avatar" instead
 */
Form.Avatar = AvatarInput;
Form.Checkbox = Checkbox;
Form.Input = Input;
Form.InputCopy = InputCopy;
Form.MemberPicker = FormMemberPicker;
Form.RadioGroup = RadioGroup;
Form.Select = Select;
Form.SpacePicker = FormSpacePicker;
Form.TagPicker = FormTagPicker;
Form.Textarea = Textarea;
Form.Toggle = Toggle;
Form.Actions = FormActions;
Form.Multiselect = Multiselect;
Form.SearchableSelect = SearchableSelect;
Form.Slider = FormSlider;
Form.File = FormFile;
Form.Image = FormImage;
Form.Layout = FormLayout;
Form.ColorPicker = FormColorPicker;
Form.DateTime = FormDateTime;
Form.LabelPicker = FormLabelPicker;
Form.PostPicker = FormPostPicker;
//# sourceMappingURL=index.js.map